import { CHECK_COBERTURA, SUCCESS_GET_COBERTURAS, FAILED_GET_COBERTURAS, RESET, CHECK_OBLIGATORIO } from '../actions/Coberturas';

const checkItem = (state, action, isPackage) => {

    switch (action.type) {

        case CHECK_COBERTURA:
            let { id, checked } = action.seleccionado



            if (isPackage === 'Y' && checked) {
                if (state.Id !== id) {
                    if (state.Id === "MENORES") {
                        return state;
                    }

                    return {
                        ...state,
                        Seleccionado: false
                    }
                }
            }



            if (isPackage === 'Y' && !checked) {
                if (state.Id !== id) {
                    if (state.Id === "MENORES") {
                        return state;
                    }

                    if (state.EsObligatorio === 'Y') {
                        return {
                            ...state,
                            Seleccionado: true
                        }
                    }
                    return {
                        ...state,
                        Seleccionado: false
                    }
                }
            }

            if (id === "MENORES") {
                if (state.Id !== id) {
                    return state;
                }
            }

            if (state.Id !== id) {

                if (state.EsPaquete === 'Y') {
                    return {
                        ...state,
                        Seleccionado: false
                    }
                }

                if (state.EsObligatorio === 'Y') {
                    return {
                        ...state,
                        Seleccionado: true
                    }
                }
                return state;
            }

            return {
                ...state,
                Seleccionado: checked
            }
        default:
            return state
    }
}

const coberturasReducer = (state = [], action) => {
    switch (action.type) {
        case SUCCESS_GET_COBERTURAS:
            return action.coberturas;
        case FAILED_GET_COBERTURAS:
            return state
        case CHECK_COBERTURA:

            const { id } = action.seleccionado;
            const { EsPaquete, EsObligatorio, Seleccionado } = state.find(w => w.Id === id);


            if (EsObligatorio === 'Y') {
                if (!Seleccionado) {
                    return state.map(cob => (cob.EsObligatorio === "Y") ? { ...cob, Seleccionado: true } : { ...cob, Seleccionado: false });
                }
                return state;
            }

            return state.map(cob => checkItem(cob, action, EsPaquete))
        case CHECK_OBLIGATORIO:
            return state.map(cob => (cob.EsObligatorio === 'Y') ? { ...cob, Seleccionado: true } : cob)
        case RESET:
            return state.map(cob => {
                cob.Seleccionado = false
                return cob
            })
        default:
            return state
    }
}

export default coberturasReducer;